








































































import { Component, Vue, Watch } from 'vue-property-decorator';
import { companyServer, dictServe, doublePrevention, patrolManagementServe, performanceServer, regionServe, yunnanDataViewServer } from '@/api/installServer';
import { arrayToTree } from '@/util/arrayToTree';

@Component({
  components: {},
})
export default class RiskAndDangerDialog extends Vue {
  private visible = false;
  type: any = '';

  // 执行部门
  subSpaceByAuthOptions: any = [];

  formData: any = {
    areaId: '',
    code: '',
    name: '',
    patrolEquipId: '',
    pid: '',
    type: '',
    riskPointType: '',
    companyPlaceType: '',
    companyId: '',
  };

  private patrolEquipList: any = []; // 巡检点code列表
  private riskPointTypeList: any = []; // 风险点类型
  private companyList: any = []; // 企业列表

  userRules: any = {
    areaId: [{ required: true, trigger: 'change', message: '请选择区域' }], // 区域
    name: [{ required: true, trigger: 'blur', message: '请填写名称' }], // 名称
    riskPointType: [{ required: true, trigger: 'change', message: '请选择风险点类型' }], // 名称
    companyPlaceType: [{ required: true, trigger: 'change', message: '请选择企业类型' }], // 名称
    companyId: [{ required: true, trigger: 'change', message: '请选择企业' }], // 名称
  };

  private async showAddDialog(data: any, rowData: any) {
    this.type = data.handleType;
    this.getDictDataOption('riskEventType'); // 字典-风险点类型
    this.getCompanyList();
    const info: any = localStorage.getItem('userInfo');
    const userData: any = JSON.parse(info);
    if (data.handleType === 'add') {
      this.formData = {
        areaId: userData.areaId,
        code: '',
        name: '',
        patrolEquipId: '',
        pid: '',
        riskPointType: '',
        companyPlaceType: '',
        companyId: '',
      };
      this.formData.type = data.type;
      if (data.type === '危险源') {
        this.formData.pid = data.pid;
      }
    } else {
      this.formData = rowData;
    }
    await this.getSpaceAreaData();
    await this.getPatrolEquipAll({ spaceId: userData.spaceId, paging: false });
    console.log(this.formData, 'this.formData------------------');
    this.visible = true;
  }
  getDictDataOption(name: any) {
    const dictTypeList: any = [];
    dictServe
      .getDetailsMapByName(name)
      .then((res: any) => {
        for (const key in res.data) {
          dictTypeList.push({
            id: key,
            label: res.data[key],
            value: res.data[key],
          });
        }
        this.riskPointTypeList = dictTypeList;
      })
      .catch((error: any) => {
        this.$message.warning('获取数据失败!');
      });
  }
  getCompanyList() {
    companyServer
      .getCompanySelectList({
        companyPlaceType: 'COMPANY',
      })
      .then((res: any) => {
        this.companyList = res.data;
      });
  }

  // 区域列表
  getSpaceAreaData() {
    regionServe.getAreaAndSubAreaList({ areaId: this.formData.areaId }).then((res: any) => {
      if (res.code === '200') {
        this.subSpaceByAuthOptions = arrayToTree(res.data);
      } else {
        this.$message.warning('获取区域的列表失败！');
      }
    });
  }
  /**
   * 【接口】获取全部该空间下的所有巡检设备
   */
  async getPatrolEquipAll(opts: object) {
    try {
      const res: any = await patrolManagementServe.getPatrolEquipData(opts);
      if (res.code === '200') {
        this.patrolEquipList = res.data;
      } else {
        this.$message.warning('网络异常，请稍后重试。');
        throw new Error();
      }
    } catch (e) {
      throw new Error();
    }
  }

  /**
   * 检查巡检点是否被绑定
   */
  checkPointBind() {
    const arrObj = this.patrolEquipList;
    try {
      arrObj.forEach((item: any) => {
        if (item.id == this.formData.patrolEquipId) {
          this.formData.patrolEquipId = '';
          this.formData.code = '';
          if (item.bindStatus) {
            this.$confirm('该巡检点已经被绑定,是否从原来绑定的设备上解除绑定，重新绑定现在的设备?', '警告', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning',
            })
              .then(() => {
                this.formData.patrolEquipId = item.id;
                this.formData.code = item.code;
              })
              .catch(() => {});
          } else {
            this.formData.patrolEquipId = item.id;
            this.formData.code = item.code;
          }
          throw new Error();
        }
      });
    } catch (e) {}
  }

  /**
   * @description 点击保存按钮
   */
  saveDialog() {
    const formComponent: any = this.$refs.form;
    formComponent.validate((valid: any) => {
      if (!valid) {
        return;
      }
      switch (this.type) {
        case 'add':
          this.addFunctionData();
          break;
        case 'edit':
          this.editFunctionData();
      }
    });
  }

  /**
   * 【接口】行内新增功能
   */
  private async addFunctionData() {
    const obj: any = {
      areaId: this.formData.areaId,
      patrolEquipId: this.formData.patrolEquipId,
      code: this.formData.code,
      name: this.formData.name,
      type: this.formData.type,
    };
    if (this.formData.type === '风险点') {
      obj.riskPointType = this.formData.riskPointType;
      obj.companyPlaceType = this.formData.companyPlaceType;
      if (this.formData.companyPlaceType === 'COMPANY') {
        obj.companyId = this.formData.companyId;
        if (this.formData.companyId) {
          obj.companyName = this.companyList.find((item: any) => item.id === this.formData.companyId).companyName;
        }
      }
    }
    if (this.formData.type === '危险源') {
      obj.pid = this.formData.pid;
    }
    doublePrevention
      .addRiskPointDangerSource(obj)
      .then((res: any) => {
        if (res.code === '200') {
          this.$message.success('添加成功');
          this.returnDialog(); // 返回到父级页面
          this.$emit('refreshData');
        } else {
          this.$message.warning(res.msg);
        }
      })
      .catch(() => {
        this.$message.error('添加失败');
      });
  }
  /**
   * 【接口】行内新增功能
   */
  private async editFunctionData() {
    const obj: any = {
      areaId: this.formData.areaId,
      code: this.formData.code,
      patrolEquipId: this.formData.patrolEquipId,
      id: this.formData.id,
      name: this.formData.name,
      type: this.formData.type,
    };
    if (this.formData.type === '风险点') {
      obj.riskPointType = this.formData.riskPointType;
      obj.companyPlaceType = this.formData.companyPlaceType;
      if (this.formData.companyPlaceType === 'COMPANY') {
        obj.companyId = this.formData.companyId;
        if (this.formData.companyId) {
          obj.companyName = this.companyList.find((item: any) => item.id === this.formData.companyId).companyName;
        }
      }
    }
    if (this.formData.type === '危险源') {
      obj.pid = this.formData.pid;
    }
    doublePrevention
      .editRiskPointDangerSource(obj)
      .then((res: any) => {
        if (res.code === '200') {
          this.$message.success('编辑成功');
          this.returnDialog(); // 返回到父级页面
          this.$emit('refreshData');
        } else {
          this.$message.warning(res.msg);
        }
      })
      .catch(() => {
        this.$message.error('编辑失败');
      });
  }
  /**
   * @description 点击返回按钮 关闭弹窗
   */
  returnDialog() {
    this.formData = {
      areaId: '',
      code: '',
      name: '',
      patrolEquipId: '',
      pid: '',
      type: '',
    };
    this.visible = false;
  }
}
